import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
const faqs = [{
  question: 'Why a golf bag for straws?',
  answer: 'Because sustainability sticks when it is joyful. Wrapping reusable straws in a mini golf bag turns an everyday habit into something you actually want to use — and show off.'
}, {
  question: 'How is the Birdie Bag better for the planet?',
  answer: 'The straws are reusable stainless steel — one set replaces hundreds of plastic ones. The caddy itself is 3D-printed in plant-derived PLA, a renewable material made from corn starch rather than fossil fuels.'
}, {
  question: 'Are the straws dishwasher safe?',
  answer: 'Yes — the stainless steel straws are fully dishwasher safe, and the included brush makes hand-washing easy too.'
}, {
  question: 'How long can the engraving be?',
  answer: 'Up to 8 characters on the side pocket. First names, nicknames, or initials all work beautifully.'
}, {
  question: 'How can I get one?',
  answer: 'Birdie Bag is a small, independent project. Get in touch via the contact links or our Instagram and we will walk you through how to request yours.'
}, {
  question: 'Where is the Birdie Bag made?',
  answer: 'Every Birdie Bag is designed and 3D-printed in Europe — built to last and finished with care.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 md:py-32 px-4 bg-white" data-id="element-10">
      <div className="max-w-3xl mx-auto" data-id="element-11">
        <div className="text-center mb-16" data-id="element-12">
          <div className="text-xs uppercase tracking-[0.25em] text-green font-medium mb-4" data-id="element-13">
            Good to know
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-charcoal" data-id="element-14">
            Questions & Answers
          </h2>
        </div>

        <div className="space-y-3" data-id="element-15">
          {faqs.map((faq, index) => <div key={index} className="bg-cream rounded-2xl overflow-hidden border border-stone" data-id="element-16">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left font-medium text-charcoal hover:bg-stone/30 transition-colors gap-4" data-id="element-17">
                <span data-id="element-18">{faq.question}</span>
                <PlusIcon className={`w-5 h-5 text-green flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`} data-id="element-19" />
              </button>
              <AnimatePresence data-id="element-20">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-21">
                    <div className="px-6 pb-5 text-charcoal/70 leading-relaxed border-t border-stone pt-4" data-id="element-22">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}